import React from 'react';
import { Box } from '@material-ui/core';

export const TabPanel = ({ children, value, name, ...other }) => (
  <Box role="tabpanel" hidden={value !== name} id={`brands-tabpanel-${name}`} aria-labelledby={`brands-tab-${name}`} {...other}>
    {value === name && <Box className={other.className}>{children}</Box>}
  </Box>
);

export const a11yProps = (index: number) => ({
  id: `brands-tab-${index}`,
  'aria-controls': `brands-tab-panel-${index}`,
});
